import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  label: {
    marginBottom: theme.spacing(0.5),
  },
}));
